export const MAX_WORD_LENGTH = 5;
export const MAX_CHALLENGES = 20;
export const ALERT_TIME_MS = 2000;
export const REVEAL_TIME_MS = 350;
export const GAME_LOST_INFO_DELAY = (MAX_WORD_LENGTH + 1) * REVEAL_TIME_MS;
export const WELCOME_INFO_MODAL_MS = 350;
// March 22, 2022 Game Epoch
// export const EPOCH = new Date(2022, 2, 28).valueOf();
export const EPOCH_LUXON = {
  year: 2022,
  month: 3,
  day: 28,
};
